// @ts-check
/**
 * @import { Ref } from 'vue'
 */
import { computed, nextTick, ref } from 'vue'
import { dependedCharConvert } from '@/utils/DependedChar'
import { isValidFormat } from '@/utils/Email'
import { countVisibleLength } from '@/utils/countVisibleLength'

/**
 * @param {Ref<HTMLFormElement|undefined>} refForm
 * @returns
 */
export const setup = refForm => {
  const oldLoginId = /** @type {HTMLInputElement|undefined} */ (document.getElementById('old_login_id'))?.value ?? ''
  const oldLoginPw =
    /** @type {HTMLInputElement|undefined} */ (document.getElementById('old_login_password'))?.value ?? ''

  const isResetDone = /** @type {HTMLInputElement} */ (document.getElementById('is_reset_done'))?.value ?? ''

  /** @type { Ref<string|null> } */
  const loginId = ref(oldLoginId)
  /** @type { Ref<string|null> } */
  const loginPw = ref(oldLoginPw)
  /** @type { Ref<string[]> } */
  const loginIDErrorMessage = ref([])
  /** @type { Ref<string[]> } */
  const loginPWErrorMessage = ref([])
  /** @type { Ref<boolean> } */
  let isValidLoginId = ref(true)
  /** @type { Ref<boolean> } */
  let isValidLoginPw = ref(true)
  /** @type {Ref<string>} */
  const grecaptchaToken = ref('')

  /** */
  const errorMessageList = computed(() => {
    return {
      login_id: loginIDErrorMessage.value,
      login_pw: loginPWErrorMessage.value,
    }
  })

  /** */
  const btnDisabled = computed(() => {
    return !isValidLoginId.value || !isValidLoginPw.value
  })

  /** */
  const checkLoginID = () => {
    const loginIDText = loginId.value ?? ''
    if (countVisibleLength(loginIDText) === 0) {
      loginIDErrorMessage.value = []
      isValidLoginId.value = false
    } else if (countVisibleLength(loginIDText) > 150) {
      loginIDErrorMessage.value = ['「メールアドレス」は150文字以内で入力してください']
      isValidLoginId.value = false
    } else if (!isValidFormat(loginIDText)) {
      loginIDErrorMessage.value = ['メールアドレスは正しい形式で入力してください']
      isValidLoginId.value = false
    } else {
      loginIDErrorMessage.value = []
      isValidLoginId.value = true
    }
  }
  /** */
  const checkLoginPW = () => {
    const loginPWText = loginPw.value ?? ''
    const loginPWTextLength = dependedCharConvert(loginPWText.replace(/\r?\n/g, '')).length
    if (loginPWTextLength == 0) {
      loginPWErrorMessage.value = []
      isValidLoginPw.value = false
    } else if (loginPWTextLength < 6 || loginPWTextLength > 20) {
      loginPWErrorMessage.value = ['「パスワード」は6～20文字で入力してください']
      isValidLoginPw.value = false
    } else {
      loginPWErrorMessage.value = []
      isValidLoginPw.value = true
    }
  }
  /** */
  checkLoginID()
  /** */
  checkLoginPW()

  /** @type {boolean} */
  let canSubmit = true

  /** */
  window.addEventListener('pageshow', event => {
    // bfcache対策
    if (event.persisted) {
      canSubmit = true
    }
  })
  /** */
  const formSubmit = () => {
    // double click
    if (!canSubmit) return

    canSubmit = false

    const grecaptchaSiteKey = /** @type{HTMLInputElement|undefined} */ (document.getElementById('grecaptcha_site_key'))
      ?.value

    if (grecaptchaSiteKey && grecaptchaSiteKey.length) {
      window.grecaptcha.enterprise.ready(() => {
        window.grecaptcha.enterprise.execute(grecaptchaSiteKey, { action: 'login' }).then(
          token => {
            /**
             * onfulfilled
             * @see {@link PromiseLike.then}
             */
            grecaptchaToken.value = token

            nextTick(() => {
              refForm.value?.submit()
            })
          },
          () => {
            /**
             * onrejected
             * @see {@link PromiseLike.then}
             */

            refForm.value?.submit()
          },
        )
      })
    } else {
      refForm.value?.submit()
    }
  }

  return {
    loginId: loginId,
    loginPw: loginPw,
    errorMessageList: errorMessageList,
    btnDisabled: btnDisabled,
    isResetDone,
    formSubmit: formSubmit,
    checkLoginID: checkLoginID,
    checkLoginPW: checkLoginPW,
    grecaptchaToken,
  }
}
